import React from 'react';

import { AppointmentTranscriptDisplay } from '@eluve/frontend-feature-appointment';

import { useInSessionTranscript } from '../machines/transcription/hooks/useInSessionTranscript';
import { useTranscriptionMachineSelector } from '../machines/transcription/hooks/useTranscriptionMachine';

export const AppointmentInSessionTranscript: React.FC<{
  compact?: boolean;
  inSession?: boolean;
  className?: string;
}> = ({ compact, inSession, className }) => {
  const { interimTranscript, isTranscriptionDegraded, recordingStartedAt } =
    useInSessionTranscript();

  const isCurrentlyRecording = useTranscriptionMachineSelector((s) =>
    s.matches({
      InSession: 'Recording',
    }),
  );

  return (
    <AppointmentTranscriptDisplay
      compact={compact}
      inSession={inSession}
      className={className}
      interimTranscript={interimTranscript}
      isTranscriptionDegraded={isTranscriptionDegraded}
      recordingStartedAt={recordingStartedAt}
      isCurrentlyRecording={isCurrentlyRecording}
    />
  );
};
